import { Breakpoints } from '@volkswagen-onehub/components-core';

export const size = {
  s: `${Breakpoints.default}px`,
  m: `${Breakpoints.b560}px`,
  l: `${Breakpoints.b960}px`,
  xl: `${Breakpoints.b1280}px`,
  xxl: `${Breakpoints.b1600}px`,
  xxxl: `${Breakpoints.b1920}px`,
};

export const minimalScreenWidth = {
  s: `(min-width: ${size.s})`,
  m: `(min-width: ${size.m})`,
  l: `(min-width: ${size.l})`,
  xl: `(min-width: ${size.xl})`,
  xxl: `(min-width: ${size.xxl})`,
  xxxl: `(min-width: ${size.xxxl})`,
};

export const maximalScreenWidth = {
  m: `(max-width: ${size.m})`,
  l: `(max-width: ${size.l})`,
  xl: `(max-width: ${size.xl})`,
  xxl: `(max-width: ${size.xxl})`,
  xxxl: `(max-width: ${size.xxxl})`,
};
